import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionDescription: {
    id: 'fastCover.baggageTravellerTugo.sectionDescription',
    defaultMessage: 'This section relates to the loss, damage, destruction or theft of personal effects owned by and travelling with the insured. This coverage has conditions, limitations and exclusions; please refer to your policy booklet for details.',
  },
  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.baggageTravellerTugo.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What happened to you baggage and personal effects?',
  },
  lostStolenOrDamagedItems: {
    id: 'fastCover.baggageTravellerTugo.lostStolenOrDamagedItems',
    defaultMessage: 'Lost, stolen or damaged items',
  },
  cash: {
    id: 'fastCover.baggageTravellerTugo.cash',
    defaultMessage: 'Cash',
  },
  baggageDelay: {
    id: 'fastCover.baggageTravellerTugo.baggageDelay',
    defaultMessage: 'Baggage delay',
  },
  hasLuggageBeenReturned: {
    id: 'fastCover.baggageTravellerTugo.hasLuggageBeenReturned',
    defaultMessage: 'Has your baggage been returned to you?',
  },
  dateWhenLuggageWasReturned: {
    id: 'fastCover.baggageTravellerTugo.dateWhenLuggageWasReturned',
    defaultMessage: 'Date when baggage was returned',
  },
  expenseFor: {
    id: 'fastCover.baggageTravellerTugo.expenseFor',
    defaultMessage: 'Expense For',
  },
  selectInsuredForExpense: {
    id: 'fastCover.baggageTravellerTugo.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },
  descriptionOfExpense: {
    id: 'fastCover.baggageTravellerTugo.descriptionOfExpense',
    defaultMessage: 'Description of expense',
  },
  dateOfExpenses: {
    id: 'fastCover.baggageTravellerTugo.dateOfExpenses',
    defaultMessage: 'Date of expense',
  },
  amountClaimed: {
    id: 'fastCover.baggageTravellerTugo.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  currency: {
    id: 'fastCover.baggageTravellerTugo.currency',
    defaultMessage: 'Currency',
  },
  providerName: {
    id: 'fastCover.baggageTravellerTugo.providerName',
    defaultMessage: 'Provider Name',
  },
  addItem: {
    id: 'fastCover.baggageTravellerTugo.addItem',
    defaultMessage: 'Add Expense',
  },
  isRequired: {
    id: 'fastCover.baggageTravellerTugo.isRequired',
    defaultMessage: '\'{defaultMessage}\' is required',
  },
  checkEventDate: {
    id: 'fastCover.baggageTravellerTugo.checkEventDate',
    defaultMessage: 'Please enter a valid date',
  },
  lostOrDamagedBaggage: {
    id: 'fastCover.baggageTravellerTugo.lostOrDamagedBaggage',
    defaultMessage: 'Lost or Damaged Baggage',
  },
  stolenBaggage: {
    id: 'fastCover.baggageTravellerTugo.stolenBaggage',
    defaultMessage: 'Stolen Baggage',
  },
  delayedBaggage: {
    id: 'fastCover.baggageTravellerTugo.delayedBaggage',
    defaultMessage: 'Delayed Baggage',
  },
  wasBaggageLostOrDamagedWhileInPossessionOfAirline: {
    id: 'fastCover.baggageTravellerTugo.wasBaggageLostOrDamagedWhileInPossessionOfAirline',
    defaultMessage: 'Was your baggage lost or damaged while in possession of the airline?',
  },
  numberOfCheckedBags: {
    id: 'fastCover.baggageTravellerTugo.numberOfCheckedBags',
    defaultMessage: 'Number of checked bags',
  },
  baggageCheckNumbers: {
    id: 'fastCover.baggageTravellerTugo.baggageCheckNumbers',
    defaultMessage: 'Baggage check number(s)',
  },
  dateBaggageCheckIssued: {
    id: 'fastCover.baggageTravellerTugo.dateBaggageCheckIssued',
    defaultMessage: 'Date baggage check issued',
  },
  dateLossReportedToAirline: {
    id: 'fastCover.baggageTravellerTugo.dateLossReportedToAirline',
    defaultMessage: 'Date loss reported to airline',
  },
  dateClaimedWithAirline: {
    id: 'fastCover.baggageTravellerTugo.dateClaimedWithAirline',
    defaultMessage: 'Date claimed with airline',
  },
  wasBaggageLostOrDamagedSomewhereElse: {
    id: 'fastCover.baggageTravellerTugo.wasBaggageLostOrDamagedSomewhereElse',
    defaultMessage: 'Was your baggage lost or damaged somewhere else?',
  },
  describeBaggageLostOrDamaged: {
    id: 'fastCover.baggageTravellerTugo.describeBaggageLostOrDamaged',
    defaultMessage: 'Describe how your baggage was lost or damaged',
  },
  toWhichAuthorityDidYouReportTheTheft: {
    id: 'fastCover.baggageTravellerTugo.toWhichAuthorityDidYouReportTheTheft',
    defaultMessage: 'To which authority did you report the theft?',
  },
  dateBaggageSupposedToArrive: {
    id: 'fastCover.baggageTravellerTugo.dateBaggageSupposedToArrive',
    defaultMessage: 'Date the baggage was supposed to arrive',
  },
  timeBaggageSupposedToArrive: {
    id: 'fastCover.baggageTravellerTugo.timeBaggageSupposedToArrive',
    defaultMessage: 'Time the baggage was supposed to arrive',
  },
  dateBaggageActuallyArrived: {
    id: 'fastCover.baggageTravellerTugo.dateBaggageActuallyArrived',
    defaultMessage: 'Date the baggage actually arrived',
  },
  timeBaggageActuallyArrived: {
    id: 'fastCover.baggageTravellerTugo.timeBaggageActuallyArrived',
    defaultMessage: 'Time the baggage actually arrived',
  },
  hasReceivedAirlineRefund: {
    id: 'fastCover.baggageTravellerTugo.hasReceivedAirlineRefund',
    defaultMessage: 'Have you received any credit or refund from Airline?',
  },
  amountCreditedRefunded: {
    id: 'fastCover.baggageTravellerTugo.amountCreditedRefunded',
    defaultMessage: 'Amount credited/refunded',
  },
  reimbursementSuffix: {
    id: 'fastCover.baggageTravellerTugo.reimbursementSuffix',
    defaultMessage: '(Reimbursement)',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.BaggageAndPersonalItemsTraveller/messages.js